import { render, staticRenderFns } from "./AdminCompaniesView.vue?vue&type=template&id=89382368&"
import script from "./AdminCompaniesView.vue?vue&type=script&lang=js&"
export * from "./AdminCompaniesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports